export const WS_DEFAULT_RK = 'default';
export const WS_DEFAULT_NAME = 'Your Workspace';
export const WS_DEFAULT_TAB_ID = 'library';
export const WS_TAB_PREFIX = 'ws:';
export const WS_STORE_KEY = 'jerny_workspaces';
export const WS_SAVE_DEBOUNCE_MS = 1000;
export const WS_ENGINE_NAME = 'WorkspaceEngine';
